import { useQueryClient } from '@tanstack/react-query';
import { CHECK_LOGIN_KEY } from '_api';
import useApiMutation from '_api/mutations/useApiMutation';
import {
  GET_ALL_ACTIVE_THERAPIST_KEY,
  GET_ALL_ADMIN_THERAPIST_KEY,
  GET_THERAPIST_KEY,
} from '_api/queries/therapist';
import { GET_USER_KEY } from '_api/queries/user';
import { Admin, Therapist, TherapistPayload } from '_api/types';

export const UPDATE_THERAPIST_KEY = 'update-therapist';

export const useUpdateTherapist = () => {
  const queryClient = useQueryClient();
  return useApiMutation<Therapist, TherapistPayload>(
    () => '/therapist',
    'put',
    {},
    {
      mutationKey: [UPDATE_THERAPIST_KEY],
      onSuccess: (_data, body: TherapistPayload) => {
        queryClient.invalidateQueries({ queryKey: [GET_THERAPIST_KEY] });
        queryClient.invalidateQueries({ queryKey: [GET_ALL_ADMIN_THERAPIST_KEY] });
        queryClient.invalidateQueries({ queryKey: [GET_ALL_ACTIVE_THERAPIST_KEY] });
        const me = queryClient.getQueryData<Admin>([CHECK_LOGIN_KEY]);
        if (body.id) {
          queryClient.invalidateQueries({ queryKey: [GET_USER_KEY, body.id] });
        }
        if (me && body.id === me.id) {
          queryClient.invalidateQueries({ queryKey: [CHECK_LOGIN_KEY] });
        }
      },
    },
  );
};
